import axios from 'axios';
import csrfToken from '../../shared/meta';

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

export default function createDisplayedAnnouncement(payload) {
  return axios.post('/api/v1/displayed_announcement', payload, { headers });
}
